<template>
  <div
    @click="toggleDetails"
    class="profile__history-item"
    role="button">
    <div
      :class="classStatus"
      class="profile__history-icon"></div>
    <div class="profile__history-data">
      <span class="profile__history-text">
        {{ `${$t('chat.closed-by')} ${agentName}` }}</span>
      <span class="profile__history-text profile__history-text--faded">{{ campaignName }}</span>
    </div>
    <div class="profile__history-badge">{{ lastMessage }}</div>
    <div
      ref="historyDetail"
      class="profile__history-detail">
      <span class="profile__history-text">{{ categoryLabel }}</span>
      <span class="profile__history-text profile__history-text--faded">{{ commentary }}</span>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';

export default {
  props: {
    history: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      isDetailsShowing: false,
    };
  },
  computed: {
    classStatus() {
      return {
        'profile__history-icon--warning': this.history.status.key === 'closed',
        'profile__history-icon--success': this.history.status.key === 'finished',
      };
    },
    agentName() {
      return this.history.agent.name ?? '';
    },
    campaignName() {
      return this.history.campaign.name ?? '';
    },
    lastMessage() {
      const date = this.history.lastMessageAt || this.history.updatedAt;

      return this.globalFromNow(date);
    },
    category() {
      const category = this.history.tags.find(({ typeTag }) => typeTag === 'Category');
      return category ?? {};
    },
    categoryName() {
      return this.category.name ?? '';
    },
    subcategory() {
      const subcategory = this.history.tags.find(({ typeTag }) => typeTag === 'Subcategory');
      return subcategory ?? {};
    },
    subcategoryName() {
      return this.subcategory.name ?? '';
    },
    categoryLabel() {
      return this.categoryName + (this.subcategoryName.length > 0 ? ` / ${this.subcategoryName}` : '');
    },
    commentary() {
      return this.history.comments ?? '';
    },
  },
  methods: {
    toggleDetails() {
      if (this.isDetailsShowing) {
        this.hideDetails();
      } else {
        this.showDetails();
      }
    },
    showDetails() {
      this.isDetailsShowing = true;
      gsap.to(this.$refs.historyDetail, 0.4, { width: 'calc(100% - 40px)', ease: 'power2.out' });
    },
    hideDetails() {
      this.isDetailsShowing = false;
      gsap.to(this.$refs.historyDetail, 0.4, { width: 0, ease: 'power2.out' });
    },
  },
};
</script>
